const LiverColor = {
  colorPattern: [
    '#d7d2ff',
    '#fadc6e',
    '#afe6ff',
    '#ffc3d2',
    '#87f0dc'
  ],
  init() {
    this.changeColor();
    const liverLinks = document.querySelectorAll('a[data-color-index]');
    if(liverLinks.length === 0) return;

    liverLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        const colorIndex = link.getAttribute('data-color-index');
        sessionStorage.setItem('liverColorIndex', colorIndex);
      })
    })
  },
  changeColor() {
    let colorIndex = sessionStorage.getItem('liverColorIndex');
    if(colorIndex === null) {
      colorIndex = Math.floor(Math.random() * 5);
    } else {
      colorIndex = parseInt(colorIndex, 10);
      sessionStorage.removeItem('liverColorIndex');
    }

    const selectedColor = this.colorPattern[colorIndex];
    document.documentElement.style.setProperty('--bgAnimationColor', selectedColor);
  }
}

export default LiverColor;
